import { render, staticRenderFns } from "./AuthPage.vue?vue&type=template&id=22a8ca84&scoped=true"
import script from "./AuthPage.ts?vue&type=script&lang=ts&external"
export * from "./AuthPage.ts?vue&type=script&lang=ts&external"
import style0 from "./AuthPage.vue?vue&type=style&index=0&id=22a8ca84&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a8ca84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22a8ca84')) {
      api.createRecord('22a8ca84', component.options)
    } else {
      api.reload('22a8ca84', component.options)
    }
    module.hot.accept("./AuthPage.vue?vue&type=template&id=22a8ca84&scoped=true", function () {
      api.rerender('22a8ca84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Auth/pages/AuthPage/AuthPage.vue"
export default component.exports